<template>
  <div>
    <v-card flat>
      <v-card-text class="pt-0">
        <fieldset class="srs_fset">
          <div class="clearfix">
            <v-form class="filtersSeries">
              <v-row>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select :key="keySelect" v-model="inputs.classgroup" :items="itemsClassgroup"
                    :label="$tc('page.series.selected-class-group')" ref="inputRaces" outlined dense
                    @change="getResults"
                    :no-data-text="$t('common.no_data')"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="my-3">
                <v-col class="group-resp" cols="12" sm="8">
                  <v-btn @click="refreshScores" class="mb-3 mr-2">{{ $t('page.series.refresh') }}</v-btn>
                </v-col>
                <v-col class="d-flex" cols="12" sm="4">
                  <v-select 
                    v-model="inputs.events" 
                    :items="items.events" 
                    :label="$tc('page.series.selected-event')"
                    ref="inputRaces" 
                    dense 
                    persistent-hint 
                    :multiple="true" 
                    :outlined="true" 
                    @change="getResults"
                    :no-data-text="$t('common.no_data')"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">
                        (+{{ inputs.events.length - 1 }} {{ $t("page.race-scores.others") }})
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
            <br />
            <VueTabulator ref="tabulator" v-model="listData" :options="tabulatorOptions" style="width: 100%" />
            <v-dialog v-model="dialog" max-width="600px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ $t('page.series.edit-participant', {
                    firstName: this.inputs.form.firstName,
                    lastName:
                      this.inputs.form.lastName
                  }) }}</span>
                  <v-icon class="ml-auto" @click="close">fa-times</v-icon>
                </v-card-title>
                <v-card-text>
                  <v-form ref="formEdit" class="formEdit">
                    <br />
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense 
                          v-model="inputs.form.place"
                          :label="$tc('common.form.place')"
                          :rules= "[
                            value => $inputRules({value}, 'integer') || $t('page.race-scores.place-invalid')
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field outlined dense :label="$tc('common.form.total')" v-model="inputs.form.total"
                          :rules="[
                            value => $inputRules({value}, 'integer') || $t('page.race-scores.total-invalid')
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-card v-for="(races, index) in inputs.form.races" :key="index">
                      <v-card-title>
                        <span class="headline">{{ races.eventName }} - {{ races.raceName }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field v-if="headerSelect != 'Classes' && headerSelect != 'Groups'" outlined dense
                              :label="$t('page.series.table.results.rd-points')" v-model="races.overallPoints"
                              :rules="[
                                (value) => $inputRules({value}, 'integer') || $t('page.race-scores.points-invalid')
                              ]"
                              ></v-text-field>
                            <v-text-field v-if="headerSelect == 'Classes'" outlined dense
                              :label="$t('page.series.table.results.rd-points')" v-model="races.classPoints"
                              :rules="[
                                (value) => $inputRules({value}, 'integer') || $t('page.race-scores.points-invalid')
                              ]"
                              ></v-text-field>
                            <v-text-field v-if="headerSelect == 'Groups'" outlined dense
                              :label="$t('page.series.table.results.rd-points')" v-model="races.groupPoints"
                              :rules="[
                                (value) => $inputRules({value}, 'integer') || $t('page.race-scores.points-invalid')
                              ]"
                              ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field v-if="headerSelect != 'Classes' && headerSelect != 'Groups'" outlined dense
                              :label="$t('page.series.table.results.rd-label')"
                              v-model="races.overallLabel"
                              :rules="[
                                (value) => $inputRules({value, minSize: 1, maxSize: 255}, 'fieldLength') || $t('page.race-scores.label-invalid')
                              ]"
                            ></v-text-field>
                            <v-text-field v-if="headerSelect == 'Classes'" outlined dense
                              :label="$t('page.series.table.results.rd-label')"
                              v-model="races.classLabel"
                              :rules="[
                                (value) => $inputRules({value, minSize: 1, maxSize: 255}, 'fieldLength') || $t('page.race-scores.label-invalid')
                              ]"
                            ></v-text-field>
                            <v-text-field v-if="headerSelect == 'Groups'" outlined dense
                              :label="$t('page.series.table.results.rd-label')"
                              v-model="races.groupLabel"
                              :rules="[
                                (value) => $inputRules({value, minSize: 1, maxSize: 255}, 'fieldLength') || $t('page.race-scores.label-invalid')
                              ]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>

                    </v-card>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="darken-1" dark small @click="close">{{ $tc('common.form.cancel') }}</v-btn>
                  <v-btn color="darken-1" dark small @click="save">{{ $tc('common.form.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </fieldset>
      </v-card-text>
    </v-card>

    <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')"
      @cancel="dialogNotification = false;" @agree="deleteItem" type="warning" :acept="$t('common.form.delete')"
      :reject="$t('common.form.cancel')" />
    <v-snackbar v-model="snackbar" timeout="3000" :color="color_snackbar">
      {{ msg_snackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          <v-icon>fas fa-times-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import
  {
    apiCalls
  } from "@/mixins/apiCalls.js";
import
  {
    mapState
  } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

export default {
  mixins: [apiCalls],
  components: {
    SGSNotificationConfirm
  },
  data()
  {
    return {
      dialogNotification: false,
      dialog: false,
      editorType: 'new',
      keySelect: 0,
      dataSeries: [],
      inputs: {
        races: -1,
        form: {
          participants: undefined,
          loadParticipant: undefined,
          id: '',
          userId: '-1',
          raceId: '',
          firstName: '',
          lastName: '',
          groupName: '',
          brand: '',
          className: '',
          overallPosition: '',
          classPosition: '',
          groupPosition: '',
          positionLabel: '',
          workerPoints: undefined,
          place: '',
          total: ''
        },
        classgroup: 0
      },
      items: {
        races: []
      },
      table: {
        data: []
      },
      serieItem: {
        inf: null
      },
      filters: {},
      participants: [],
      selectedParticipant: undefined,
      column_items: [],
      column: [],
      seriesResults: [],
      columnsLoad: [],
      listData: [],
      userCurrent: null,
      snackbar: false,
      color_snackbar: '',
      msg_snackbar: '',
      listWorkerPoints: [],
      participantsSeries: [],
      classSeries: [],
      headerSelect: '',
      loadInitial: false,
      responseGroup: [],
      responseClass: []
    }
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    }),
    headers()
    {
      return [{
        text: this.$t("page.series.table.results.race-name"),
        value: "raceName",
        filter: f =>
        {
          if (this.filters.racename == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.racename.toLowerCase())
        }
      },
      {
        text: this.$t("common.form.user-id"),
        value: "userId",
        filter: f =>
        {
          if (this.filters.userid == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.userid.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.first-name"),
        value: "firstName",
        filter: f =>
        {
          if (this.filters.firstname == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.firstname.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.last-name"),
        value: "lastName",
        filter: f =>
        {
          if (this.filters.lastname == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.lastname.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.group-name"),
        value: "groupName",
        filter: f =>
        {
          if (this.filters.groupname == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.groupname.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.brand"),
        value: "brand",
        filter: f =>
        {
          if (this.filters.brand == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.brand.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.class-name"),
        value: "className",
        filter: f =>
        {
          if (this.filters.classname == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.classname.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.overall-position"),
        value: "overallPosition",
        filter: f =>
        {
          if (this.filters.overallposition == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.overallposition.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.class-position"),
        value: "classPosition",
        filter: f =>
        {
          if (this.filters.classposition == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.classposition.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.group-position"),
        value: "groupPosition",
        filter: f =>
        {
          if (this.filters.groupposition == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.groupposition.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.position-label"),
        value: "positionLabel",
        filter: f =>
        {
          if (this.filters.positionlabel == undefined)
          {
            if (!f)
            {
              return true;
            }
            return f;
          }
          return (f + '').toLowerCase().includes(this.filters.positionlabel.toLowerCase())
        }
      },
      {
        text: this.$t("page.series.table.results.actions"),
        value: "actions"
      },
      ];
    },
    selectParticipants()
    {
      const response = [];
      const length = (this.participants || []).length

      for (var i = 0; i < length; i++)
      {
        response[i] = [];
        response[i].value = this.participants[i].id;
        response[i].participantIndex = i;
        response[i].text = `${this.participants[i].lastName}, ${this.participants[i].firstName} (${this.participants[i].raceClassName})`
      }

      return response;
    },
    firstNameRules: function ()
    {
      return [v => !!v || this.$t("page.race-scores.first-name-required")];
    },
    lastNameRules: function ()
    {
      return [v => !!v || this.$t("page.race-scores.last-name-required")];
    },
    groupNameRules: function ()
    {
      return [v => !!v || this.$t("page.race-scores.group-name-required")];
    },
    brandRules: function ()
    {
      return [v => !!v || this.$t("page.race-scores.brand-required")];
    },
    classNameRules: function ()
    {
      return [v => !!v || this.$t("page.race-scores.class-name-required")];
    },
    overallPositionRules: function ()
    {
      return [v => (!v || (v && v.length <= 5)) || this.$t("page.race-scores.overall-position-max-lenght-5")];
    },
    classPositionRules: function ()
    {
      return [v => (!v || (v && v.length <= 5)) || this.$t("page.race-scores.class-position-max-lenght-5")];
    },
    groupPositionRules: function ()
    {
      return [v => (!v || (v && v.length <= 5)) || this.$t("page.race-scores.group-position-max-lenght-5")];
    },
    positionLabelRules: function ()
    {
      return [v => !!v || this.$t("page.race-scores.position-label-required")];
    },
    seriesId()
    {
      if (this.seriesSelected)
      {
        return this.seriesSelected.id;
      }
      return 0;
    },
    tabulatorOptions() {
      return {
        placeholder: this.$t("common.table.no-data"),
        tooltips: true,
        addRowPos: "top",
        height: "600",
        layout: "fitColumns",
        resizableColumns: false,
        movableColumns: true,
        columns: []
      };
    },
    columns() {
      return [
        {
          title: " " + this.$t("page.series.table.results.actions"),
          field: "actions",
          visible: false,
          columns: [
            {
              title: "",
              field: "edit",
              width: 40,
              minWidth: 40,
              hozAlign: "center",
              headerSort: false,
              formatter: function ()
              {
                return "<i class='fa fa-edit'></i>";
              }.bind(this),
              cellClick: function (e, cell)
              {
                const data = cell.getData();
                this.editItem(data);
              }.bind(this),
            },
            {
              title: "",
              field: "delete",
              width: 40,
              minWidth: 40,
              hozAlign: "center",
              headerSort: false,
              formatter: function ()
              {
                return "<i class='fa fa-trash'></i>";
              }.bind(this),
              cellClick: function (e, cell)
              {
                const data = cell.getData();
                this.confirmDelete(data);
              }.bind(this),
            },
          ],
        },
        {
          title: this.$t("page.series.table.results.first-name"),
          field: "firstName",
          visible: true,
          sorter: "string",
          sorterParams: {
            alignEmptyValues: "bottom"
          },
          minWidth: 90,
          cssClass: "srs-col-horizontal srs-col-wrap",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          formatter: "textarea"
        },
        {
          title: this.$t("page.series.table.results.last-name"),
          field: "lastName",
          visible: true,
          sorter: "string",
          sorterParams: {
            alignEmptyValues: "bottom"
          },
          width: 90,
          minWidth: 90,
          cssClass: "srs-col-horizontal srs-col-wrap",
          headerFilter: "input",
          headerFilterPlaceholder: " "
        },
        {
          title: this.$t("page.series.table.results.class-name"),
          field: "className",
          visible: true,
          sorter: "alphanum",
          sorterParams: {
            alignEmptyValues: "bottom"
          },
          minWidth: 120,
          cssClass: "srs-col-horizontal srs-col-wrap",
          headerFilterPlaceholder: " ",
          headerFilter: 'select',
          headerFilterFunc: "in",
          headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
          formatter: "textarea"
        },
        {
          title: this.$t("page.series.table.results.brand"),
          field: "brand",
          visible: true,
          sorter: "string",
          sorterParams: {
            alignEmptyValues: "bottom"
          },
          minWidth: 90,
          cssClass: "srs-col-horizontal",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          formatter: "textarea"
        },
        {
          title: this.$t("page.series.table.results.place"),
          field: "place",
          visible: true,
          sorter: "number",
          sorterParams: {
            alignEmptyValues: "bottom"
          },
          minWidth: 50,
          cssClass: "srs-col-horizontal",
          headerFilter: "input",
          headerFilterPlaceholder: " ",
          formatter: "textarea"
        },
        {
          title: this.$t("page.series.table.results.total"),
          field: "total",
          visible: true,
          sorter: "number",
          sorterParams: {
            alignEmptyValues: "bottom"
          },
          minWidth: 50,
          cssClass: "srs-col-horizontal",
          headerFilterPlaceholder: " ",
          headerFilter: 'input',
          formatter: "textarea"
        }
      ];
    },
    itemsClassgroup() {
      let items = [];

      let isOverall = false;
      if (this.dataSeries && Array.isArray(this.dataSeries))
      {
        this.dataSeries.forEach(element =>
        {
          if (element.classGroup == '')
          {
            isOverall = true;
          }
        });
      }

      items.push({
        header: this.$t("page.series.groups")
      });

      if (isOverall) {
          items.push({
            text: this.$t("page.series.overall"),
            value: 'overall'
          });
      }

      for (var j = 0; j < this.responseGroup.length; j++)
      {
        const element = {
          text: `${this.responseGroup[j].groupName}`,
          value: `group:${this.responseGroup[j].id}`
        };
        items.push(element);
      }

      items.push({
        header: this.$t("page.series.classes")
      });

      for (var i = 0; i < this.responseClass.length; i++)
      {
        const element = {
          text: `${this.responseClass[i].className}`,
          value: `class:${this.responseClass[i].id}`
        };
        items.push(element);
      }

      let banClass = false;

      if (this.dataSeries && Array.isArray(this.dataSeries))
      {
        this.dataSeries.forEach(element1 =>
        {
          banClass = false
          for (var i = 0; i < this.responseClass.length; i++)
          {
              if (this.normalizeClassName(this.responseClass[i].className) == this.normalizeClassName(element1.className))
              {
                banClass = true;
              }
            }
            if (!banClass)
            {
              const element = {
                text: `${element1.className}`,
                value: `className:${element1.className}`
              };
              items.push(element);
            }
        });
      }

      return items;
    }
  },
  created()
  {
    this.getRaceList();
  },
  async mounted()
  {
    this.getEvents();
    this.getParticipants();
    this.loadColumns();
    this.getWorkerPoints();
    this.getResults(true);
  },
  methods: {
    columnSelection()
    {
      const tabulatorInstance = this.$refs.tabulator.getInstance();

      for (var i = 0; i < this.column_items.length; i++)
      {

        var findColumn = this.column.find((element) => element == i);

        if (findColumn != undefined)
        {
          tabulatorInstance.showColumn(this.column_items[i].field);
        } else
        {
          tabulatorInstance.hideColumn(this.column_items[i].field);
        }
      }
    },
    loadColumns()
    {
      this.column_items = [
        {
          id: 0,
          text: this.$t("page.series.table.results.race-name"),
          field: "raceName"
        },
        {
          id: 1,
          text: this.$t("common.form.user-id"),
          field: "userId"
        },
        {
          id: 2,
          text: this.$t("page.series.table.results.first-name"),
          field: "firstName"
        },
        {
          id: 3,
          text: this.$t("page.series.table.results.last-name"),
          field: "lastName"
        },
        {
          id: 4,
          text: this.$t("page.series.table.results.group-name"),
          field: "groupName"
        },
        {
          id: 5,
          text: this.$t("page.series.table.results.brand"),
          field: "brand"
        },
        {
          id: 6,
          text: this.$t("page.series.table.results.class-name"),
          field: "className"
        },
        {
          id: 7,
          text: this.$t("page.series.table.results.overall-position"),
          field: "overallPosition"
        },
        {
          id: 8,
          text: this.$t("page.series.table.results.class-position"),
          field: "classPosition"
        },
        {
          id: 9,
          text: this.$t("page.series.table.results.group-position"),
          field: "groupPosition"
        },
        {
          id: 10,
          text: this.$t("page.series.table.results.position-label"),
          field: "positionLabel",
        },
        {
          id: 11,
          text: this.$t("page.series.table.results.actions"),
          field: "actions"
        }
      ];

      this.column = [
        {
          id: 0,
          text: this.$t("page.series.table.results.race-name"),
          field: "raceName"
        },
        {
          id: 1,
          text: this.$t("common.form.user-id"),
          field: "userId"
        },
        {
          id: 2,
          text: this.$t("page.series.table.results.first-name"),
          field: "firstName"
        },
        {
          id: 3,
          text: this.$t("page.series.table.results.last-name"),
          field: "lastName"
        },
        {
          id: 4,
          text: this.$t("page.series.table.results.group-name"),
          field: "groupName"
        },
        {
          id: 5,
          text: this.$t("page.series.table.results.brand"),
          field: "brand"
        },
        {
          id: 6,
          text: this.$t("page.series.table.results.class-name"),
          field: "className"
        },
        {
          id: 7,
          text: this.$t("page.series.table.results.overall-position"),
          field: "overallPosition"
        },
        {
          id: 8,
          text: this.$t("page.series.table.results.class-position"),
          field: "classPosition"
        },
        {
          id: 9,
          text: this.$t("page.series.table.results.group-position"),
          field: "groupPosition"
        },
        {
          id: 10,
          text: this.$t("page.series.table.results.position-label"),
          field: "positionLabel",
        },
        {
          id: 11,
          text: this.$t("page.series.table.results.actions"),
          field: "actions"
        }
      ];
    },
    async getEvents()
    {
      const response = await this.api("get", `/api/v1/livelaps/series/races/${this.seriesSelected.id}`)
      this.items.events = [];
      for (var j = 0; j < response.length; j++)
      {
        const element = {
          text: response[j].raceOrder ? this.$t("page.series.table.results.rd") + (response[j].raceOrder) + " - " + this.$escapeHtml.decode(response[j].eventName) : this.$escapeHtml.decode(response[j].eventName),
          value: response[j].raceId
        };
        this.items.events.push(element)
      }
    },
    async getParticipants()
    {
      if (this.seriesSelected)
      {
        const url = `/api/v1/promoter/series/${this.seriesSelected.id}/results/participants`;
        const response = await this.api("get", url);

        const data = response.message;
        this.participants = data;
        this.participantsSeries = data.filter((el) =>
        {
          return el.lastName && el.lastName != '' && el.firstName && el.firstName != '' && el.raceClassName && el.raceClassName != '';
        }).map((el) =>
        {
          return {
            value: el.id,
            text: `${el.lastName}, ${el.firstName} (${el.raceClassName})`
          };
        });
      }
    },
    resetFilters()
    {
      this.filters.forEach((item) =>
      {
        this.$refs.tabulator.getInstance().setHeaderFilterValue(item.field, item.value);
      });
    },
    async getRaceList()
    {
      if (this.seriesSelected)
      {
        let responseClass = await this.api("get", `/api/v1/promoter/series/${this.seriesSelected.id}/class`);
        let responseGroup = await this.api("get", `/api/v1/promoter/series/group/${this.seriesSelected.id}`);
        responseClass = responseClass.message.data
        responseGroup = responseGroup.message.data
        this.responseGroup = responseGroup;
        this.responseClass = responseClass;
        const response = await this.api("get", `/api/v1/promoter/series/results/${this.seriesSelected.id}`)
        this.dataSeries = response.data;

        let isOverall = false;
        if (this.dataSeries && Array.isArray(this.dataSeries))
        {
          this.dataSeries.forEach(element =>
          {
            if (element.classGroup == '')
            {
              isOverall = true;
            }
          });
        }

        this.classSeries = responseClass;

        if (isOverall)
        {
          this.inputs.classgroup = 'overall'
        } else if (responseGroup.length > 0)
        {
          this.inputs.classgroup = `group:${responseGroup[0].id}`
          this.getResults();
        } else if (responseClass.length > 0)
        {
          this.inputs.classgroup = `class:${responseClass[0].id}`
          this.getResults();
        }

        this.keySelect++
      }
    },
    getHeaderSelect()
    {
      return this.getClassGroupSelection().headerSelect;
    },
    normalizeClassName(className)
    {
      return (className || "").trim().replace(/\s+/g, "").toLowerCase();
    },
    getClassGroupSelection()
    {
      let name = '';
      const selectedValue = `${this.inputs.classgroup}`;

      if (this.itemsClassgroup)
      {
        for (let el of this.itemsClassgroup)
        {
          if (!el.header && `${el.value}` == selectedValue)
          {
            name = el.text;
            break;
          }
        }
      }

      let headerSelect = '';
      if (selectedValue.indexOf('group:') === 0)
        headerSelect = 'Groups';
      else if (selectedValue.indexOf('class:') === 0 || selectedValue.indexOf('className:') === 0)
        headerSelect = 'Classes';

      return { headerSelect, name };
    },
    async getResults(reloadTable = false)
    {
      if (this.seriesSelected)
      {
        const response = await this.api("get", `/api/v1/promoter/series/results/${this.seriesSelected.id}`)

        this.dataSeries = response.data;

        if (response && response.data && Array.isArray(response.data) && response.data.length > 0)
        {
          this.table.data = [];
          const { headerSelect, name } = this.getClassGroupSelection();

          await response.data.forEach((element) =>
          {
            const row = {
              id: element.finalScoresId,
              userId: element.id,
              firstName: element.firstName.trim(),
              lastName: element.lastName.trim(),
              brand: element.brand,
              className: element.className,
              groupName: element.classGroup,
              races: element.races,
              actions: "actions"

            };
            const classSelect = this.classSeries.find((el) =>
            {
              return this.normalizeClassName(el.className) == this.normalizeClassName(element.className);
            });
            if (!classSelect && (element.className || "").length > 0)
            {
              this.classSeries.push({ className: element.className, disabled: true });
            }

            for (var i = 0; i < element.races.length; i++)
            {
              if (element.races[i].scores)
              {
                if (headerSelect == "Groups")
                {
                  row['rd' + i + 'label'] = element.races[i].scores.groupLabel
                  row['rd' + i + 'position'] = element.races[i].scores.groupPosition
                  row['rd' + i + 'points'] = element.races[i].scores.groupPointsFS || (element.races[i].scores.groupPointsFS == null ? element.races[i].scores.groupPointsSPP : 0) || (element.races[i].scores.groupPosition ? 0 : "")
                } else if (headerSelect == "Classes")
                {
                  row['rd' + i + 'label'] = element.races[i].scores.classLabel
                  row['rd' + i + 'position'] = element.races[i].scores.classPosition
                  row['rd' + i + 'points'] = element.races[i].scores.classPointsFS || (element.races[i].scores.classPointsFS == null ? element.races[i].scores.classPointsSPP : 0) || (element.races[i].scores.classPosition ? 0 : "")
                } else if (headerSelect == '' || headerSelect == 'Overall')
                {
                  row['rd' + i + 'label'] = element.races[i].scores.overallLabel
                  row['rd' + i + 'position'] = element.races[i].scores.overallPosition
                  row['rd' + i + 'points'] = element.races[i].scores.overallPointsFS || (element.races[i].scores.overallPointsFS == null ? element.races[i].scores.overallPointsSPP : 0) || (element.races[i].scores.overallPosition ? 0 : "")
                } else
                {
                  row['rd' + i + 'label'] = ""
                  row['rd' + i + 'position'] = ""
                  row['rd' + i + 'points'] = ""
                }
              }
            }
            if (headerSelect == "Groups")
            {
              row.place = element.groupPosition;
              row.total = element.groupPoints;
              if ((element.classGroup || "").trim().toLowerCase() == (name || "").trim().toLowerCase())
                this.table.data.push(row);
            } else if (headerSelect == "Classes")
            {
              row.place = element.classPosition;
              row.total = element.classPoints;
              if (this.normalizeClassName(element.className) == this.normalizeClassName(name))
                this.table.data.push(row);
            } else if (headerSelect == "")
            {
              row.place = element.overallPosition
              row.total = element.overallPoints
              if (element.classGroup == '' || element.classGroup == null)
                this.table.data.push(row);
            } else
            {
              row.place = element.overallPosition;
              row.total = element.overallPoints;
              this.table.data.push(row);
            }

          });

          if (!reloadTable)
          {
            this.listData = this.table.data;
          } else
          {
            let columns = [];
            let columnsFilters = [];
            let races = response.data[0].races;
            if (races.length > 0)
            {
              for (var k = 0; k < races.length; k++)
              {
                columnsFilters.push('rd' + k + 'points');
                columnsFilters.push('rd' + k + 'label');
                let _column = {
                  title: this.$t("page.series.table.results.rd") + (response.data[0].races[k].raceOrder) + " - " + response.data[0].races[k].eventName + " <br> " + response.data[0].races[k].raceName,
                  field: "action",
                  visible: true,
                  "hozAlign": "center",
                  "download": false,
                  columns: [
                    {
                      title: this.$t("page.series.table.results.rd-points"),
                      field: 'rd' + k + 'points',
                      visible: true,
                      sorter: "number",
                      sorterParams: {
                        alignEmptyValues: "bottom"
                      },
                      minWidth: 90,
                      cssClass: "srs-col-horizontal",
                      headerFilter: "input",
                      headerFilterPlaceholder: " ",
                      formatter: "textarea"

                    },
                    {
                      title: this.$t("page.series.table.results.rd-position"),
                      field: 'rd' + k + 'label',
                      visible: true,
                      sorter: "alphanum",
                      sorterParams: {
                        alignEmptyValues: "bottom"
                      },
                      minWidth: 90,
                      cssClass: "srs-col-horizontal",
                      headerFilter: "input",
                      headerFilterPlaceholder: " ",
                      formatter: "textarea"
                    }
                  ]
                };
                if (this.inputs.events)
                {
                  this.inputs.events.forEach(element =>
                  {
                    if (element === response.data[0].races[k].raceId)
                    {
                      columns.push(_column);
                    }
                  });
                } else
                {
                  columns.push(_column);
                }
              }
            }
            columns = this.columns.concat(columns);
            this.$refs.tabulator.getInstance().setColumns(columns);
            this.filters = this.$refs.tabulator.getInstance().getHeaderFilters();
            this.$refs.tabulator.getInstance().replaceData(this.table.data).then(() =>
            {
              this.resetFilters();
            });
            this.$refs.tabulator.getInstance().showColumn("edit");
            this.$refs.tabulator.getInstance().showColumn("delete");
          }
          if (reloadTable)
          {
            let columns = [];
            let races = response.data[0].races;

            if (races.length > 0)
            {
              if ((!this.inputs.events && !Array.isArray(this.inputs.events)) || (Array.isArray(this.inputs.events) && this.inputs.events.length == 0))
              {
                this.inputs.events = [];
              }
              for (var j = 0; j < races.length; j++)
              {
                let _column = {
                  title: (response.data[0].races[j].raceOrder ? (this.$t("page.series.table.results.rd") + (response.data[0].races[j].raceOrder) + " - ") : "") + response.data[0].races[j].eventName + " <br> " + response.data[0].races[j].raceName,
                  field: "action",
                  visible: true,
                  "hozAlign": "center",
                  "download": false,
                  columns: [
                    {
                      title: this.$t("page.series.table.results.rd-points"),
                      field: 'rd' + j + 'points',
                      visible: true,
                      sorter: "number",
                      sorterParams: {
                        alignEmptyValues: "bottom"
                      },
                      minWidth: 90,
                      cssClass: "srs-col-horizontal",
                      headerFilter: "input",
                      headerFilterPlaceholder: " ",
                      formatter: "textarea"

                    },
                    {
                      title: this.$t("page.series.table.results.rd-position"),
                      field: 'rd' + j + 'label',
                      visible: true,
                      sorter: "alphanum",
                      sorterParams: {
                        alignEmptyValues: "bottom"
                      },
                      minWidth: 90,
                      cssClass: "srs-col-horizontal",
                      headerFilter: "input",
                      headerFilterPlaceholder: " ",
                      formatter: "textarea"
                    }
                  ]
                };
                if (typeof this.items.events[0] != 'undefined' && response.data[0].races[j].raceId == this.items.events[0].value && !this.loadInitial)
                {
                  this.loadInitial = true;
                  if (!this.inputs.events.includes(response.data[0].races[j].raceId)) this.inputs.events.push(response.data[0].races[j].raceId);
                  columns.push(_column);
                } else
                {
                  const find = this.inputs.events.find((item) => { return item == response.data[0].races[j].raceId });
                  if (find)
                  {
                    columns.push(_column);
                  }
                }
              }

            }
            columns = this.columns.concat(columns);
            this.$refs.tabulator.getInstance().setColumns(columns);
            this.$refs.tabulator.getInstance().showColumn("edit");
            this.$refs.tabulator.getInstance().showColumn("delete");
          }
        } else
        {
          this.$refs.tabulator.getInstance().setColumns(this.columns);
          this.$refs.tabulator.getInstance().hideColumn("edit");
          this.$refs.tabulator.getInstance().hideColumn("delete");
          this.listData = [];
        }
      }
    },
    editItem(item)
    {

      this.headerSelect = this.getHeaderSelect();
      this.inputs.form.id = item.id;
      this.inputs.form.userId = item.userId;
      this.inputs.form.firstName = item.firstName;
      this.inputs.form.lastName = item.lastName;
      this.inputs.form.groupName = item.groupName;
      this.inputs.form.brand = item.brand;
      const classSelect = this.classSeries.find((el) => { return el.className == item.className });
      this.inputs.form.className = classSelect ? classSelect : item.className;
      this.inputs.form.workerPoints = item.workerPoints;
      this.inputs.form.place = item.place;
      this.inputs.form.total = item.total;

      this.inputs.form.races = []
      for (var i = 0; i < item.races.length; i++)
      {

        if (item.races[i].scores.finalScoresId)
        {
          if (this.headerSelect == 'Groups')
          {
            this.inputs.form.races.push({
              id: item.races[i].scores.finalScoresId,
              raceId: item.races[i].raceId,
              positionLabel: item.races[i].scores.positionLabel,
              groupPosition: item.races[i].scores.groupPosition,
              groupPoints: item.races[i].scores.groupPointsFS || (item.races[i].scores.groupPointsFS == null ? item.races[i].scores.groupPointsSPP : 0) || (item.races[i].scores.groupPosition ? 0 : ""),//item.races[i].scores.groupPointsFS,
              raceName: item.races[i].raceName,
              eventName: item.races[i].eventName,
              groupLabel: item.races[i].scores.groupLabel
            });
          } else if (this.headerSelect == 'Classes')
          {
            this.inputs.form.races.push({
              id: item.races[i].scores.finalScoresId,
              raceId: item.races[i].raceId,
              positionLabel: item.races[i].scores.positionLabel,
              classPosition: item.races[i].scores.classPosition,
              classPoints: item.races[i].scores.classPointsFS || (item.races[i].scores.classPointsFS == null ? item.races[i].scores.classPointsSPP : 0) || (item.races[i].scores.classPosition ? 0 : ""),//item.races[i].scores.classPointsFS,
              raceName: item.races[i].raceName,
              eventName: item.races[i].eventName,
              classLabel: item.races[i].scores.classLabel
            });
          } else
          {
            this.inputs.form.races.push({
              id: item.races[i].scores.finalScoresId,
              raceId: item.races[i].raceId,
              positionLabel: item.races[i].scores.positionLabel,
              overallPosition: item.races[i].scores.overallPosition,
              overallPoints: item.races[i].scores.overallPointsFS || (item.races[i].scores.overallPointsFS == null ? item.races[i].scores.overallPointsSPP : 0) || (item.races[i].scores.overallPosition ? 0 : ""),//item.races[i].scores.overallPointsFS,
              raceName: item.races[i].raceName,
              eventName: item.races[i].eventName,
              overallLabel: item.races[i].scores.overallLabel
            });
          }
        }

      }

      this.editorType = 'edit';
      if (this.$refs.formEdit) this.$refs.formEdit.resetValidation();
      this.dialog = true;
    },
    async save()
    {
      if (this.$refs.formEdit.validate())
      {
        let data = this.inputs.form;
        if (data.className.groupName)
        {
          data.groupName = data.className.groupName;
          data.className = data.className.className;
        } else
        {
          data.className = data.className.className;
        }
        data.type = "Points";
        const headerSelect = this.getHeaderSelect();
        data.subType = headerSelect == "Classes" ? "class" : (headerSelect == "Groups" ? "group" : "overall");
        data.seriesId = this.seriesSelected.id;

        let url = '/api/v1/promoter/series/points/';
        url = this.editorType == 'edit' ? `${url}${data.id}` : url;

        const method = this.editorType == 'edit' ? 'PUT' : 'POST';

        const response = await this.api(method, url, data);

        if (response)
        {
          this.getResults(true)
          this.close();
        }
      }
    },
    close()
    {
      this.dialog = false;
      this.dialogNotification = false;
    },
    confirmDelete(item)
    {
      this.dialogNotification = true
      this.item = item
    },
    async deleteItem()
    {

      const response = await this.deleteApi(`/api/v1/promoter/series/results/points/${this.item.id}`);
      if (response != undefined)
      {
        this.getResults(true)
        this.close();
      }
    },
    async importScores()
    {
      const result = await this.api(
        "post",
        "/api/v1/promoter/race",
        { force: true, raceId: this.inputs.races });
      if (result.success)
      {
        if ([11, 10, 9, 6, 3, 0].includes(result.message.mode))
        {
          if (!this.userCurrent)
          {
            const getUserCurrent = await this.api("get", "/api/v1/users/current");
            this.userCurrent = getUserCurrent.message;
          }
          const importResult = await this.api(
            "get",
            "/api/v1/promoter/series/import/" + this.inputs.races//+"?uds="+this.userCurrent.id+"&apikey=d96742bc-5980-43ce-9cf3-554e4a551c04"
          );
          const importSucceeded = importResult && (
            importResult.success === true ||
            importResult.success === 1 ||
            importResult.status === 'queued'
          );

          if (importSucceeded) {
            this.msg_snackbar = this.$t('common.success');
            this.color_snackbar = 'success';
            this.snackbar = true;
          } else {
            this.msg_snackbar = this.$t('page.series.failed_import');
            this.color_snackbar = 'error';
            this.snackbar = true;
          }
        } else
        {
          this.msg_snackbar = this.$t('page.series.invalid_mode');
          this.color_snackbar = 'error';
          this.snackbar = true;
        }
      }

    },
    async publishSeries()
    {
      if (!this.userCurrent)
      {
        const getUserCurrent = await this.api("get", "/api/v1/users/current");
        this.userCurrent = getUserCurrent.message;
      }
      const result = await this.api(
        "post",
        "/api/v1/promoter/series/publishSeries",
        { seriesId: this.seriesSelected.id, userId: this.userCurrent.id });
      if (result.success)
      {
        this.msg_snackbar = this.$t('common.success');
        this.color_snackbar = 'success';
        this.snackbar = true;
      } else
      {
        this.msg_snackbar = this.$t('page.series.failed_publish');
        this.color_snackbar = 'error';
        this.snackbar = true;
      }
    },
    refreshScores()
    {
      this.getResults();
      this.keySelect++
    },
    async getWorkerPoints()
    {
      if (this.seriesSelected)
      {
        const response = await this.api(
          "get",
          "/api/v1/promoter/series/getWorkerPoints/" + this.seriesSelected.id);
        if (response.success)
        {
          this.listWorkerPoints = response.message.map((el) =>
          {
            return { value: el.id, text: `${el.workerPointsSchemaName} (${el.workerPointsSchemaDescription})` }
          });
        }
      }
    },
    formatPosition(cell)
    {
      const position = cell.getValue();
      if (!position) return "";
      const data = cell.getData();
      const field = cell.getField();
      const fieldLabel = field.replace("position", "label");
      return fieldLabel, data[field] + " " + (data[fieldLabel] ? data[fieldLabel] : "");
    }
  },
  watch: {
    seriesSelected()
    {
      this.getParticipants();
      this.getRaceList();
      this.getResults(true);
      this.getWorkerPoints();
      this.inputs.races = -1;
      this.inputs.events = [];
      this.items.events = [];
      this.getEvents();
      setTimeout(() =>
      {
        this.refreshScores();
      }, 1000);
    },
    'inputs.form.loadParticipant': {
      handler: function (after)
      {
        const part = this.participants.find((el) =>
        {
          return el.id == after;
        });
        if (part)
        {
          this.inputs.form.brand = part.brand;
          this.inputs.form.className = part.raceClassName;
          this.inputs.form.firstName = part.firstName;
          this.inputs.form.lastName = part.lastName;
          this.inputs.form.userId = part.userId;
        }
      },
      deep: true
    }
  }
};
</script>

<style>
.group-resp {
  display: block;
}

.group-resp .v-btn {
  min-height: 36px;
  white-space: normal;
  max-width: 100%;
  float: left;
  display: block;
}

.orlbl {
  font-weight: bold;
  font-size: 14px;
  margin-right: 20px;
}

.newseriesbtn {
  margin-top: 0px !important;
}

.srs_fset {
  padding: 0.35em 0.625em 0.75em !important;
  margin: 5px !important;
  border: 1px solid var(--v-lighten-base) !important;
}

.srs_lgd {
  width: auto !important;
  font-size: 15px !important;
  border-bottom: none !important;
  margin-bottom: 0px !important;
}

.customlink {
  color: var(--v-primary-lighten1);
  font-weight: bold;
  text-decoration: underline;
}

.tabscard {
  margin: 10px 5px;
}

.v-tab {
  text-transform: initial;
}

.text-start {
  vertical-align: baseline;
}

.formEdit .v-text-field__details,
.formEdit .v-messages {
  min-height: 0;
  display: flex !important;
}

.formEdit .v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot,
.formEdit .v-select__slot {
  min-height: 32px;
  height: 34px;
}

.formEdit .col-12 {
  padding: 6px 12px;
}

.formEdit .v-text-field--outlined.v-input--dense .v-label {
  top: 7px;
}

.filtersSeries .v-text-field__details,
.filtersSeries .v-messages {
  display: none;
}

.filtersSeries .v-input {
  font-size: 14px;
}

.filtersSeries .v-chip.v-size--default {
  height: 26px;
  font-size: 12px;
}

.tabulator-row .tabulator-frozen.tabulator-frozen-right {
  background-color: var(--v-lighten-darken1);
}

.tabulator[tabulator-layout=fitColumns] .tabulator-row .tabulator-cell:last-of-type {
  background-color: var(--v-lighten-darken1);
}

.tabulator .tabulator-header .tabulator-frozen.tabulator-frozen-right {
  height: 100% !important;
  background: #495464 !important;
}

.tabulator-frozen.tabulator-frozen-right .tabulator-col-content {
  margin-top: 110% !important;
}

.tabulator-col-group-cols {
  height: auto !important;

}

.tabulator .tabulator-header .tabulator-col.tabulator-col-group .tabulator-col-group-cols {
  display: -webkit-box !important;
  height: auto !important;
}

.tabulator[tabulator-layout=fitColumns] .tabulator-row .tabulator-cell:last-of-type {
  background-color: transparent !important;
}

.tabulator .tabulator-header {
  background: #495464 !important;
}

.tabulator .tabulator-header .tabulator-col {
  background-color: #495464 !important;
  color: white;
  border-right: 1px solid rgba(255, 255, 255, 0.25) !important;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content {
  font-size: 13px !important;
  padding: 4px !important;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-title {
  white-space: normal !important;
  line-height: 1.3;
  text-align: center;
  padding-bottom: 4px;
}

.tabulator .tabulator-header .tabulator-col .tabulator-header-filter {
  width: 100%;
}

.tabulator .tabulator-header .tabulator-col .tabulator-header-filter input {
  border: 1px solid #aaa;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
}

.tabulator .tabulator-header .tabulator-col-group {
  border-right: 1px solid rgba(255, 255, 255, 0.25) !important;
}

.srs-col-wrap .tabulator-col-title {
  word-break: break-word;
}

.srs-col-nowrap .tabulator-col-title {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
